/**
 *
 * @param {String} url
 * @returns {String}
 */
export default function fixVideoUrl(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }

  const { hostname, pathname, searchParams } = parsed;

  if (hostname === 'youtu.be') {
    const id = pathname.slice(1);
    return `https://www.youtube.com/embed/${id}`;
  }

  if (hostname.includes('youtube') && !pathname.includes('/embed/')) {
    const id = searchParams['get']('v');
    if (id) {
      return `https://www.youtube.com/embed/${id}`;
    }
  }

  if (hostname.includes('vimeo') && !hostname.includes('player')) {
    const pathSegments = pathname.split('/').filter(Boolean);
    const [id, hash] = pathSegments;

    if (hash) {
      searchParams['set']('h', hash);
    }

    const queryString = searchParams.toString();
    return `https://player.vimeo.com/video/${id}${queryString ? '?' + queryString : ''}`;
  }

  return url;
}
